var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.deleteClickAction}},[_c('v-icon',{attrs:{"color":"#74B8BE"}},[_vm._v("mdi-close-circle")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }